import React from 'react';
import { CircularProgress } from '@material-ui/core';

const LoadingBasic = () => (
  <div className='loading-overlay'>
    <CircularProgress color="secondary" />
  </div>
)

export default LoadingBasic;